// The create page's choice icons, from the canvas board: pixel art drawn as rects (decorative).

/** Minecraft: Java Edition: a grass block. */
export function GrassBlockIcon() {
  return (
    <svg className="choice-icon" width="40" height="40" viewBox="0 0 8 8" shapeRendering="crispEdges" aria-hidden="true">
      <rect width="8" height="8" fill="#7a4a2a" />
      <rect width="8" height="3" fill="#5f9e45" />
      <rect x="0" y="3" width="1" height="1" fill="#5f9e45" />
      <rect x="3" y="3" width="2" height="1" fill="#5f9e45" />
      <rect x="7" y="3" width="1" height="1" fill="#5f9e45" />
      <rect x="1" y="0" width="1" height="1" fill="#79b35c" />
      <rect x="5" y="1" width="1" height="1" fill="#79b35c" />
      <rect x="2" y="5" width="1" height="1" fill="#5a3520" />
      <rect x="5" y="6" width="1" height="1" fill="#5a3520" />
    </svg>
  );
}

/** A fresh world: a little tree. */
export function TreeIcon() {
  return (
    <span className="choice-icon choice-icon-boxed" aria-hidden="true">
      <svg width="24" height="27" viewBox="0 0 8 9" shapeRendering="crispEdges">
        <rect x="3" y="0" width="2" height="1" fill="#79b35c" />
        <rect x="1" y="1" width="3" height="2" fill="#5f9e45" />
        <rect x="4" y="1" width="3" height="2" fill="#79b35c" />
        <rect x="2" y="3" width="2" height="1" fill="#3f7a32" />
        <rect x="4" y="3" width="2" height="1" fill="#5f9e45" />
        <rect x="3" y="4" width="2" height="3" fill="#946042" />
        <rect x="1" y="7" width="6" height="2" fill="#7a4a2a" />
      </svg>
    </span>
  );
}

/** Bring your world: an upload arrow. */
export function UploadIcon() {
  return (
    <span className="choice-icon choice-icon-boxed" aria-hidden="true">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 16V4M7 9l5-5 5 5M4 20h16" />
      </svg>
    </span>
  );
}
